var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.75C16.586 9.75 16.25 9.414 16.25 9V7.99C16.25 5.652 14.348 3.75 12.01 3.75C9.653 3.75 7.75 5.652 7.75 7.99V9C7.75 9.414 7.414 9.75 7 9.75C6.586 9.75 6.25 9.414 6.25 9V7.99C6.25 4.825 8.825 2.25 11.99 2.25C15.175 2.25 17.75 4.825 17.75 7.99V9C17.75 9.414 17.414 9.75 17 9.75Z",
    fill: "#123051"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.25H6C4.483 8.25 3.25 9.483 3.25 11V19C3.25 20.517 4.483 21.75 6 21.75H18C19.517 21.75 20.75 20.517 20.75 19V11C20.75 9.483 19.517 8.25 18 8.25ZM19.25 19C19.25 19.689 18.689 20.25 18 20.25H6C5.311 20.25 4.75 19.689 4.75 19V11C4.75 10.311 5.311 9.75 6 9.75H18C18.689 9.75 19.25 10.311 19.25 11V19ZM13.25 14C13.25 14.403 13.046 14.745 12.75 14.974V16.5C12.75 16.914 12.414 17.25 12 17.25C11.586 17.25 11.25 16.914 11.25 16.5V14.974C10.954 14.745 10.75 14.403 10.75 14C10.75 13.311 11.311 12.75 12 12.75C12.689 12.75 13.25 13.311 13.25 14Z",
    fill: "#123051"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.466975b15e40bd4b695f248461fce57d.svg";
export { ForwardRef as ReactComponent };